import { HttpError, useOne } from '@refinedev/core';
import type { CalendarEvent } from 'src/meetings/models';

type UseEventResult = {
  event: CalendarEvent | null;
  isLoading: boolean;
  error: HttpError | null;
};

export const useEvent = (eventId: string): UseEventResult => {
  const { data, isLoading, error } = useOne<CalendarEvent>({
    resource: 'calendar-events',
    id: eventId,
  });

  return {
    event: data?.data || null,
    isLoading,
    error,
  };
};
